export default __webpack_public_path__ + "static/logo_greater_houston_partnership-5e47bd2ab3a54a71833f2a665ab2f32b.png";